/**
 * @file: InspectMenu.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 日巡查配置
 */
import request from '@/utils/request'

/**
 * 获取日巡查承包商列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuContratorListGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/contrator/list/get',
    method: 'post',
    data
  })
}

/**
 * 食安大数据分析，今日日巡查统计分页列表(导出全部数据)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuDataAnalyStatisticsExport(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/data/analy/statistics/export',
    method: 'post',
    data
  })
}

/**
 * 食安大数据分析，今日日巡查统计(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuDataAnalyStatisticsGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/data/analy/statistics/get',
    method: 'post',
    data
  })
}

/**
 * 食安大数据分析，今日日巡查统计分页列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuDataAnalyStatisticsList(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/data/analy/statistics/list',
    method: 'post',
    data
  })
}

/**
 * 食安大数据分析，今日日巡查统计分页列表(导出选择数据)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuDataAnalyStatisticsOptionExport(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/data/analy/statistics/option/export',
    method: 'post',
    data
  })
}

/**
 * 根据食堂ID和承包商ID查询日巡查清单(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuDeptGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/dept/get',
    method: 'post',
    data
  })
}

/**
 * 历史日巡查清单列表查询(cme)(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuHisListGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/his/list/get',
    method: 'post',
    data
  })
}

/**
 * 历史日巡查清单列表查询(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuHistoryListGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/history/list/get',
    method: 'post',
    data
  })
}

/**
 * 日巡查清单各项目列表查询(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuItemListGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/item/list/get',
    method: 'post',
    data
  })
}

/**
 * 日巡查清单各项目列表查询-按类型分类(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuItemListTypeGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/item/list/type/get',
    method: 'post',
    data
  })
}

/**
 * 更新日巡查清单项目(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuItemUpdate(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/item/update',
    method: 'post',
    data
  })
}

/**
 * 日巡查清单列表查询(wzp)(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuListGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取食堂上次日巡查时间(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuMenuDepDateGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/menu/dep/date/get',
    method: 'post',
    data
  })
}

/**
 * 根据商家查日巡查记录(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuMenuStallList(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/menu/stall/list',
    method: 'post',
    data
  })
}

/**
 * 根据食堂ID，获取日巡查清单统计(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuStatisticsDeptGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/statistics/dept/get',
    method: 'post',
    data
  })
}

/**
 * 更新日巡查清单模板的检查标识(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuTemplateCheckUpdate(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/template/check/update',
    method: 'post',
    data
  })
}

/**
 * 删除日巡查清单模板项目(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuTemplateDelete(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/template/delete',
    method: 'post',
    data
  })
}

/**
 * 日巡查模板检查清单(固定+其他)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuTemplateGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/template/get',
    method: 'post',
    data
  })
}

/**
 * 新增日巡查清单模板项目(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuTemplateInsert(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/template/insert',
    method: 'post',
    data
  })
}

/**
 * 日巡查模板需检查清单(必检)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuTemplateRequirecheckGet(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/template/requirecheck/get',
    method: 'post',
    data
  })
}

/**
 * 更新日巡查清单模板项目(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function inspectmenuTemplateUpdate(data) {
  return request({
    type: 'biz',
    url: 'inspectmenu/template/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/InspectMenu.js